module.exports = __webpack_public_path__ + "img/Group 2287.4f24be2b.svg";